import { render, staticRenderFns } from "./StockMoveFilter.vue?vue&type=template&id=c96797b2&"
import script from "./StockMoveFilter.vue?vue&type=script&lang=js&"
export * from "./StockMoveFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports